export const API = {
  // Auth endpoints
  loginGoogle: () => `/auth/login/google`,
  loginGithub: () => `/auth/login/github`,
  callbackGoogle: () => `/auth/callback/google`,
  callbackGithub: () => `/auth/callback/github`,
  refreshToken: () => `/auth/refresh`,
  getCurrentUser: () => `/auth/me`,
  register: () => `/auth/register`,
  login: () => `/auth/login`,
  forgotPassword: () => `/auth/forgot-password`,
  resetPassword: () => `/auth/reset-password`,
  verifyEmail: () => `/auth/verify-email`,
  resendVerification: () => `/auth/resend-verification`,
  
  // User endpoints
  getUserProfile: (userId: string) => `/users/${userId}`,
  updateUserProfile: (userId: string) => `/users/${userId}`,
  changePassword: (userId: string) => `/users/${userId}/change-password`,
  getExportRefundProfile: (userId: string) => `/users/${userId}/export-refund/profile`,
  saveExportRefundProfile: (userId: string) => `/users/${userId}/export-refund/profile`,
  submitExportRefundProfile: (userId: string) => `/users/${userId}/export-refund/profile/submit`,
  approveExportRefundProfile: (userId: string) => `/users/admin/users/${userId}/export-refund/profile/approve`,
  rejectExportRefundProfile: (userId: string) => `/users/admin/users/${userId}/export-refund/profile/reject`,
  issueExportRefundCard: (userId: string) => `/users/admin/users/${userId}/export-refund/issue-card`,
  uploadExportRefundProfilePhoto: (userId: string) => `/users/${userId}/export-refund/profile/photo`,
  downloadExportRefundProfilePhoto: (userId: string, filename: string) => `/users/${userId}/export-refund/profile/photo/${filename}`,
  cardFeeIntent: (userId: string) => `/users/${userId}/export-refund/card-fee-intent`,
  payCardFee: (userId: string) => `/users/${userId}/export-refund/pay-card-fee`,
  cardDepositIntent: (userId: string, amount: number) => `/users/${userId}/export-refund/card-deposit-intent?amount=${amount}`,
  depositCard: (userId: string) => `/users/${userId}/export-refund/card-deposit`,
  listExportRefundClaims: (userId: string) => `/users/${userId}/export-refund/claims`,
  createExportRefundClaim: (userId: string) => `/users/${userId}/export-refund/claims`,
  getExportRefundClaimDetail: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}`,
  updateExportRefundClaim: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}`,
  deleteExportRefundClaim: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}`,
  uploadExportRefundDocument: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}/documents`,
  downloadExportRefundDocument: (userId: string, documentId: string) => `/users/${userId}/export-refund/documents/${documentId}`,
  deleteExportRefundDocument: (userId: string, documentId: string) => `/users/${userId}/export-refund/documents/${documentId}`,
  checkClaimCompliance: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}/check-compliance`,
  exportRefundAuditExport: (userId: string) => `/users/${userId}/export-refund/audit-export`,
  claimShippingQuote: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}/shipping-quote`,
  claimShippingPaymentIntent: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}/shipping-payment-intent`,
  payClaimShippingFee: (userId: string, claimId: string) => `/users/${userId}/export-refund/claims/${claimId}/pay-shipping-fee`,

  // Shipping address book (BDD Scenario 1-A: 個人設定頁面「運送地址管理」)
  listShippingAddresses: (userId: string) => `/users/${userId}/shipping-addresses`,
  createShippingAddress: (userId: string) => `/users/${userId}/shipping-addresses`,
  updateShippingAddress: (userId: string, addressId: string) => `/users/${userId}/shipping-addresses/${addressId}`,
  deleteShippingAddress: (userId: string, addressId: string) => `/users/${userId}/shipping-addresses/${addressId}`,

  // Payment card management (Settings > Payment Cards, real Stripe SetupIntent)
  createPaymentCardSetupIntent: (userId: string) => `/users/${userId}/payment-cards/setup-intent`,
  listPaymentCards: (userId: string) => `/users/${userId}/payment-cards`,
  setDefaultPaymentCard: (userId: string, paymentMethodId: string) => `/users/${userId}/payment-cards/${paymentMethodId}/default`,
  deletePaymentCard: (userId: string, paymentMethodId: string) => `/users/${userId}/payment-cards/${paymentMethodId}`,

  // Admin endpoints
  listAdminUsers: () => `/users/admin/users`,
  adminCreateUser: () => `/users/admin/users`,
  adminUpdateUser: (userId: string) => `/users/admin/users/${userId}`,
  adminDeleteUser: (userId: string) => `/users/admin/users/${userId}`,
  listAllExportRefundClaims: () => `/users/admin/export-refund/claims`,
  adminUpdateExportRefundClaim: (claimId: string) => `/users/admin/export-refund/claims/${claimId}`,
  freezeExportRefundClaimViolation: (claimId: string) => `/users/admin/export-refund/claims/${claimId}/freeze-violation`,
  reconcileClaimShippingFee: (claimId: string) => `/users/admin/export-refund/claims/${claimId}/shipping-reconcile`,
  confirmClaimShippingBankTransfer: (claimId: string) => `/users/admin/export-refund/claims/${claimId}/confirm-shipping-bank-transfer`,
  
  // Subscription endpoints
  getSubscriptionPlans: () => `/subscriptions/plans`,
  getUserSubscription: (userId: string) => `/subscriptions/user/${userId}`,
  upgradeSubscription: (userId: string) => `/subscriptions/user/${userId}/upgrade`,
  cancelSubscription: (userId: string) => `/subscriptions/user/${userId}/cancel`,
  
  // Payment endpoints
  getUserPayments: (userId: string) => `/payments/user/${userId}`,
  getTransactions: () => `/payments/transactions`,
  createCheckoutSession: () => `/payments/checkout`,

  // Order endpoints
  createOrder: () => `/orders`,
  listOrders: () => `/orders`,
  listAdminOrders: () => `/orders/admin`,
  getOrder: (orderId: string) => `/orders/${orderId}`,
  updateOrder: (orderId: string) => `/orders/${orderId}`,
  deleteOrder: (orderId: string) => `/orders/${orderId}`,
  confirmPreauth: (orderId: string) => `/orders/${orderId}/confirm-preauth`,
  confirmOrder: (orderId: string) => `/orders/${orderId}/confirm`,
  confirmBankTransfer: (orderId: string) => `/orders/${orderId}/confirm-bank-transfer`,
  capturePayment: (orderId: string) => `/orders/${orderId}/capture`,
  shipOrder: (orderId: string) => `/orders/${orderId}/ship`,
  confirmDelivery: (orderId: string) => `/orders/${orderId}/confirm-delivery`,
  verifyInvoice: (orderId: string) => `/orders/${orderId}/verify-invoice`,
  releasePreauth: (orderId: string) => `/orders/${orderId}/release`,
  adminDeleteOrder: (orderId: string) => `/orders/admin/${orderId}`,
  adminUpdateOrder: (orderId: string) => `/orders/admin/${orderId}`,
  getOrderTracking: (orderId: string) => `/orders/${orderId}/tracking`,
  updateOrderTracking: (orderId: string) => `/orders/${orderId}/tracking`,
  setOrderShippingAddress: (orderId: string) => `/orders/${orderId}/shipping-address`,
  adminSetOrderShippingFee: (orderId: string) => `/orders/admin/${orderId}/shipping-fee`,
  orderShippingQuote: (orderId: string) => `/orders/${orderId}/shipping-quote`,
  orderShippingPaymentIntent: (orderId: string) => `/orders/${orderId}/shipping-payment-intent`,
  confirmOrderShippingPayment: (orderId: string) => `/orders/${orderId}/confirm-shipping-payment`,
  confirmOrderShippingBankTransfer: (orderId: string) => `/orders/${orderId}/confirm-shipping-bank-transfer`,
  uploadOrderItemImage: (orderId: string, itemId: string) => `/orders/${orderId}/items/${itemId}/image`,
  getOrderItemImage: (orderId: string, itemId: string) => `/orders/${orderId}/items/${itemId}/image`,

  // Package endpoints (BDD 1-A line 41: combine multiple captured orders into one shipment)
  createPackage: () => `/packages`,
  getPackage: (packageId: string) => `/packages/${packageId}`,
  setPackageShippingAddress: (packageId: string) => `/packages/${packageId}/shipping-address`,
  adminSetPackageShippingFee: (packageId: string) => `/packages/admin/${packageId}/shipping-fee`,
  packageShippingQuote: (packageId: string) => `/packages/${packageId}/shipping-quote`,
  packageShippingPaymentIntent: (packageId: string) => `/packages/${packageId}/shipping-payment-intent`,
  confirmPackageShippingPayment: (packageId: string) => `/packages/${packageId}/confirm-shipping-payment`,
  confirmPackageShippingBankTransfer: (packageId: string) => `/packages/${packageId}/confirm-shipping-bank-transfer`,

  // Rewards endpoints
  getRewardBalance: () => `/rewards/balance`,
  listRewardTransactions: () => `/rewards/transactions`,

  // Procurement / Quote endpoints
  submitProcurementRequest: () => `/procurement/requests`,
  listProcurementRequests: () => `/procurement/requests`,
  getProcurementRequest: (requestId: string) => `/procurement/requests/${requestId}`,
  updateProcurementRequest: (requestId: string) => `/procurement/requests/${requestId}`,
  deleteProcurementRequest: (requestId: string) => `/procurement/requests/${requestId}`,
  procurementRequestStats: () => `/procurement/requests/stats`,

  // Product / Inventory catalog endpoints (admin only)
  listProducts: () => `/products`,
  createProduct: () => `/products`,
  getProduct: (productId: string) => `/products/${productId}`,
  updateProduct: (productId: string) => `/products/${productId}`,
  deleteProduct: (productId: string) => `/products/${productId}`,

  // AI Sourcing Concierge chat widget (public, no auth)
  sendChatMessage: () => `/chat/message`,

  // Seasonal trend/buying advisory briefing fed into the AI concierge (admin only)
  getTrendBriefing: () => `/trend-briefing`,
  updateTrendBriefing: () => `/trend-briefing`,
};
